import script from "./OutlineButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./OutlineButton.vue?vue&type=script&setup=true&lang=ts"

import "./OutlineButton.vue?vue&type=style&index=0&id=c1166a06&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1166a06"]])

export default __exports__